import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Smartphone, Download, ShieldCheck } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpen,
    text: '6 Tomos Exclusivos'
  }, {
    icon: Gift,
    text: '6 Bonos Premium'
  }, {
    icon: Smartphone,
    text: 'Acceso desde cualquier dispositivo'
  }, {
    icon: Download,
    text: 'Descarga inmediata'
  }, {
    icon: ShieldCheck,
    text: 'Compra protegida'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface" data-id="element-299">
      <div className="max-w-4xl mx-auto text-center" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-301">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-green/10 text-brand-green font-bold text-sm tracking-wider uppercase mb-4" data-id="element-302">
            La Solución
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark mb-6" data-id="element-303">
            Presentamos el MegaPack Sistema Libre de Clearing
          </h2>
          <p className="text-lg md:text-xl text-slate font-medium max-w-2xl mx-auto" data-id="element-304">
            Una biblioteca digital creada para ayudarte a comprender el sistema,
            conocer tus derechos y tomar decisiones con mayor claridad.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-center" data-id="element-305">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-surface-gray p-6 rounded-2xl border border-gray-100 flex flex-col items-center text-center gap-4 hover:shadow-md transition-shadow" data-id="element-306">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-brand-green" data-id="element-307">
                <feature.icon className="w-6 h-6" data-id="element-308" />
              </div>
              <span className="font-bold text-slate-dark" data-id="element-309">{feature.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}